import { render, staticRenderFns } from "./TenderForm.vue?vue&type=template&id=5312f65c&scoped=true&"
import script from "./TenderForm.vue?vue&type=script&lang=js&"
export * from "./TenderForm.vue?vue&type=script&lang=js&"
import style0 from "./TenderForm.vue?vue&type=style&index=0&id=5312f65c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5312f65c",
  null
  
)

export default component.exports